module.exports = __webpack_public_path__ + "static/media/FacebookLogo.15217ff6.svg";